import { render, staticRenderFns } from "./AlphaDiversity.vue?vue&type=template&id=78861de2&scoped=true"
import script from "./AlphaDiversity.vue?vue&type=script&lang=js"
export * from "./AlphaDiversity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78861de2",
  null
  
)

export default component.exports